import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSaveRemove = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M4 4.5V18.2406C4 18.6594 4.34062 19 4.75937 19C4.91562 19 5.06875 18.9531 5.19687 18.8625L10 15.5L14.8031 18.8625C14.9313 18.9531 15.0844 19 15.2406 19C15.6594 19 16 18.6594 16 18.2406V4.5C16 3.67188 15.3281 3 14.5 3H5.5C4.67188 3 4 3.67188 4 4.5Z",
		fill: "#0D2976"
	})
});
export default SvgSaveRemove;
